import { track } from '@/utils/amplitude/analytics/core';
import { TrackingEvents, TrackingPayload } from '@/utils/amplitude/analytics/core.types';

type TrackItemUnsavedPayload = TrackingPayload;

export const trackItemUnsavedAnalytics = (payload: TrackItemUnsavedPayload) => {
    track(TrackingEvents.Item.ItemUnsaved, payload);
};
